import { render } from "./UpdateRolePermission.vue?vue&type=template&id=b4be9634"
import script from "./UpdateRolePermission.vue?vue&type=script&lang=js"
export * from "./UpdateRolePermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__